import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReportIdState {
  reportId: string | null;
}

const initialState: ReportIdState = {
  reportId: null,
};

const reportIdReducer = createSlice({
  name: "reportId",
  initialState,
  reducers: {
    setReportId: (state, action: PayloadAction<string | null>) => {
      state.reportId = action.payload;
    },
  },
});

export const { setReportId } = reportIdReducer.actions;
export default reportIdReducer.reducer;
